import { Checkbox } from '@flipster/react/design-system';
import { Portal } from '@flipster/react/misc/portal';
import segment, { ChartEvent } from '@flipster/utils/segment';

import { TvVisibleWhaleTrackerStorageKey } from '../../../misc/constants';
import { usePersistentToggle } from '../../../misc/persistent';
import { useTvHeaderContext } from '../../index';
import { WhalePositionCard } from './whale-position-card';

export const WhaleTrackerPlugin = ({
  symbol,
  onCopyClick,
}: {
  symbol: string;
  onCopyClick: (entryPrice: string) => void;
}) => {
  const tv = useTvHeaderContext();

  const [checked, setChecked] = usePersistentToggle(TvVisibleWhaleTrackerStorageKey);

  return (
    <>
      {checked && (
        <Portal selector='#tv-chart-container'>
          <WhalePositionCard
            symbol={symbol}
            quoteCurrency={
              (tv?.activeChart?.symbolExt()?.library_custom_fields?.quoteCurrency as string | undefined) ?? 'USDT'
            }
            onCopyClick={onCopyClick}
            symbolPricePrecision={tv.symbolPricePrecision}
          />
        </Portal>
      )}
      <Checkbox
        checked={checked}
        onChange={(e) => {
          setChecked(e.currentTarget.checked);
          segment.track(ChartEvent.ChartEventToggleClick, {
            event_name: 'Whale Tracker',
            action: e.currentTarget.checked ? 'turn_on' : 'turn_off',
          });
        }}
      >
        Whale Tracker
      </Checkbox>
    </>
  );
};
